// extracted by mini-css-extract-plugin
export default {"rooms":"rooms_rooms__R5Cwf","rooms__heading":"rooms_rooms__heading__Ti7ly","rooms__create":"rooms_rooms__create__fiN4X","rooms__text":"rooms_rooms__text__07ki0"};